export default __webpack_public_path__ + "static/menuBcg-d48d58d3427300e2f2e1a7056b68ba11.jpg";